module.exports = __webpack_public_path__ + "static/PrintPattern-21f52083a401d46b38f0805248c1dcbf.jpg";